import { z } from '@betty/toolkit/api';
import { PromoSchema } from '@betty/promos';

export const RegistrationOffersResponseSchema = z.object({
  items: z.array(PromoSchema),
});

export type Promotion = z.infer<typeof PromoSchema>;
